var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-delete",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.214 7.153l-0.706-2.118c-0.269-0.807-1.021-1.349-1.871-1.349h-5.938v-1.933c0-0.966-0.786-1.753-1.752-1.753h-5.438c-0.966 0-1.752 0.786-1.752 1.753v1.933h-5.938c-0.85 0-1.603 0.542-1.872 1.349l-0.707 2.118c-0.161 0.482-0.079 1.016 0.218 1.428s0.778 0.659 1.286 0.659h0.739l1.626 20.1c0.121 1.491 1.386 2.66 2.882 2.66h12.804c1.495 0 2.761-1.169 2.882-2.66l1.625-20.1h0.409c0.508 0 0.989-0.246 1.286-0.658s0.379-0.947 0.218-1.429zM11.632 1.875h5.191v1.811h-5.191v-1.811zM21.807 29.189c-0.043 0.525-0.487 0.936-1.013 0.936h-12.804c-0.525 0-0.97-0.411-1.013-0.936l-1.614-19.949h18.056l-1.613 19.949zM3.147 7.365l0.579-1.737c0.013-0.040 0.051-0.067 0.093-0.067h20.818c0.042 0 0.079 0.027 0.093 0.067l0.579 1.737h-22.162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.817 29.122c0.017 0.001 0.033 0.001 0.050 0.001 0.495 0 0.909-0.388 0.935-0.889l0.88-16.9c0.027-0.517-0.371-0.958-0.887-0.985-0.518-0.028-0.958 0.37-0.985 0.887l-0.88 16.9c-0.027 0.517 0.37 0.958 0.887 0.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.695 28.237c0.027 0.5 0.441 0.886 0.935 0.886 0.017 0 0.035-0 0.052-0.001 0.517-0.028 0.913-0.47 0.885-0.987l-0.922-16.9c-0.028-0.517-0.47-0.913-0.987-0.885s-0.913 0.47-0.885 0.987l0.922 16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.238 29.124c0.518 0 0.938-0.42 0.938-0.938v-16.9c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v16.9c0 0.518 0.42 0.938 0.938 0.938z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2649878e1556fff79d17a38b0892a692.svg";
export { ForwardRef as ReactComponent };